const EMOJI_LIST = {
  PARTY_POPPER: '🎉',
  CONFUSED_FACE: '😕',
  GRINNING_FACE: '😀'
}

export default EMOJI_LIST;
